
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { AlertTriangle } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { 
  Table, 
  TableBody, 
  TableCell, 
  TableHead, 
  TableHeader, 
  TableRow 
} from "@/components/ui/table";

interface DefaulterConsumer {
  name: string;
  accountId: string;
  location: string;
  outstandingAmount: number;
  daysOverdue: number;
  status: string;
}

interface DefaulterConsumersTableProps {
  defaulters: DefaulterConsumer[];
}

const DefaulterConsumersTable: React.FC<DefaulterConsumersTableProps> = ({ defaulters }) => {
  return (
    <Card className="mb-8">
      <CardHeader className="flex flex-row items-center justify-between">
        <div>
          <CardTitle>Top Defaulter Consumers</CardTitle>
          <CardDescription>Consumers with outstanding payment balances</CardDescription>
        </div>
        <AlertTriangle className="h-5 w-5 text-amber-500" />
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Consumer Name</TableHead>
              <TableHead>Account ID</TableHead>
              <TableHead>Location</TableHead>
              <TableHead>Outstanding Amount</TableHead>
              <TableHead>Days Overdue</TableHead>
              <TableHead>Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {defaulters.map((defaulter, index) => (
              <TableRow key={index}>
                <TableCell className="font-medium">{defaulter.name}</TableCell>
                <TableCell>{defaulter.accountId}</TableCell>
                <TableCell>{defaulter.location}</TableCell>
                <TableCell className="text-right font-medium">
                  ${defaulter.outstandingAmount.toLocaleString()}
                </TableCell>
                <TableCell>{defaulter.daysOverdue}</TableCell>
                <TableCell>
                  <Badge variant={defaulter.status === 'Critical' ? 'destructive' : 
                          defaulter.status === 'High' ? 'default' : 'outline'}>
                    {defaulter.status}
                  </Badge>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

export default DefaulterConsumersTable;
